const getMapValues = map => [...map].map(([, value]) => value);

export default getMapValues;
